import React from 'react';
import PropTypes from 'prop-types';
import {locationShape} from 'react-router';

import Go from 'spa/Components/Go';

const RemoveMultipleSlashes = ({location}) => (
  <Go to={`${location.pathname.replace(/\/\/+/g, '/')}${location.search}`} statusCode={301} />
);
RemoveMultipleSlashes.propTypes = {
  location: locationShape.isRequired, //eslint-disable-line react/no-typos
};

export default RemoveMultipleSlashes;



// WEBPACK FOOTER //
// ./spa/Pages/RemoveMultipleSlashes.jsx